var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"verification-container"},[_vm._m(0),(!_vm.errorMessage)?_c('h2',[_vm._v("Thanks for verifying your email.")]):_vm._e(),(_vm.errorMessage)?_c('h2',[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle"},[_c('div',{staticClass:"triangle-block"},[_c('div',{staticClass:"triangle"})])])
}]

export { render, staticRenderFns }